class FAQ extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {

        this.querySelectorAll(".faq-item-title").forEach((button) => {
            button.addEventListener("click", this.toggleFaqItem.bind(this));
        });

        this.querySelectorAll(".js-faq-button").forEach((button) => {
            button.addEventListener("click", this.toggleFaqGroup.bind(this));
        });

    }

    toggleFaqGroup(e) {

        document.querySelectorAll('.js-faq-button').forEach((btn) => btn.classList.remove('active'));
        e.currentTarget.classList.add('active');
        const targetId = e.currentTarget.getAttribute('data-faq-id');
        this.querySelectorAll('.faq__items-content').forEach((container) => {
            if (container.getAttribute('data-faq-id') === targetId) {
                container.classList.add('active');
            } else {
                container.classList.remove('active');
            }
        });
    }

    toggleFaqItem(e) {
        e.currentTarget
            .querySelector(".faq-close")
            .classList.toggle("faq-display-none");

        e.currentTarget.parentNode.classList.toggle("faq-item-active");

        const item = e.currentTarget.parentNode.querySelector(".faq-item-text");
        console.log(item);

        item.slideToggle("250");
    }
}

customElements.define('faq-container', FAQ);